module.exports = __webpack_public_path__ + "assets/c62bd15bb3e7f68331d17e723034023e.png";